import isType from './is-type';
export default (function (value) {
    return Array.isArray ?
        Array.isArray(value) :
        isType(value, 'Array');
});
//# sourceMappingURL=is-array.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/is-array.js
// module id = 15
// module chunks = 3